import Stylus from './Stylus';
import ConstantWidthBrush from './ConstantWidthBrush';
import highlighterIcon from '../assets/icons/marker.svg';
import { svgToIcon } from '../utils/svg';

// Free drawing highlighter

class StylusHighlighter extends Stylus {
  activate() {
    const defaultWidth = 15;
    const canvas = this.controller.canvas;
    const brush = new ConstantWidthBrush(canvas, 'highlighter', defaultWidth);
    brush.decimate = 3;
    brush.color = 'rgba(255, 255, 0, 0.4)';
    brush.width = defaultWidth;

    canvas.isDrawingMode = true;
    canvas.freeDrawingBrush = brush;
  }

  // Override the default behavior to reset to the pointer.
  drawingComplete() {}

  cursor() {
    return 'crosshair';
  }

  renderIcon() {
    return svgToIcon(highlighterIcon);
  }

  alwaysLockWhenSelected() {
    return true;
  }
}

export default StylusHighlighter;
